import React, { useEffect, useState } from 'react'
import { RiskAnalysis, RiskAnalysisStatus } from '../../../../api/schemas/schema'
import { makeStyles, tokens, Text, MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-components'
import { List } from '../../../common/list/List'
import { getSimplifiedRiskAnalyseEvaluateColumns } from '../../../../helpers/riskAnalysisHelper'
import { t } from '../../../../i18n/i18n'
import { RiskAssessmentBadge } from '../../RiskBadges'
import { ModalRiskAnalyseEvaluate } from '../ModalRiskAnalyseEvaluate'
import { CardHeader } from '../../../common/header/CardHeader'
import { IItemState } from '../../../../interfaces/IItemState'

const useStyles = makeStyles({
   phoneItemWrapper: {
      '& > *': {
         marginBottom: tokens.spacingVerticalMNudge,
      },
      display: 'flex',
      flexDirection: 'column',
      marginBottom: tokens.spacingVerticalM,
   },
})

type SimplifiedRiskAnalyseEvaluateProps = {
   analysisState: IItemState<RiskAnalysis>
   setRiskAnalysisState: React.Dispatch<React.SetStateAction<IItemState<RiskAnalysis>>>
}

export const SimplifiedRiskAnalyseEvaluate = ({ analysisState, setRiskAnalysisState }: SimplifiedRiskAnalyseEvaluateProps) => {
   const classes = useStyles()
   const [risks, setRisks] = useState<any>([])
   const [selectedRisk, setSelectedRisk] = useState<any>(null)
   const [modals, setModals] = useState({
      determineModal: false,
      analyseEvaluateModal: false,
   })
   const analysis = analysisState.item
   const disabled = analysisState.disabled || risks.length === 0 || analysis.status !== RiskAnalysisStatus.Ongoing

   const toggleModal = (modalName: string, isOpen: boolean) => {
      setModals({
         determineModal: false,
         analyseEvaluateModal: false,
         [modalName]: isOpen,
      })
   }

   const handleRiskClick = (risk: any) => {
      toggleModal('analyseEvaluateModal', true)
      setSelectedRisk(risk)
   }

   const phoneBody = (item: any) => {
      return (
         <>
            <span>
               <div className={classes.phoneItemWrapper}>
                  <RiskAssessmentBadge largeBadge status={item.status} />
                  <Text>{item.scenario}</Text>
               </div>
            </span>
         </>
      )
   }

   useEffect(() => {
      if (analysis.simplifiedRisks.length > 0) {
         setRisks(analysis.simplifiedRisks)
      } else if (analysis.consequenceAndProbabilityRisks.length > 0) {
         setRisks(analysis.consequenceAndProbabilityRisks)
      }
   }, [analysis])

   return (
      <>
         <CardHeader
            title={t('RiskAnalysis&Evaluation')}
         />

         {risks.length === 0 ? (
            <MessageBar intent={'info'}>
               <MessageBarBody>
                  <MessageBarTitle>{t('NoRisksIdentifiedYet')}</MessageBarTitle>
               </MessageBarBody>
            </MessageBar>
         ) : (
            <List columns={getSimplifiedRiskAnalyseEvaluateColumns()} items={risks} onRowClick={handleRiskClick} renderPhoneBodyItem={phoneBody} />
         )}

         <ModalRiskAnalyseEvaluate
            setRiskAnalysisState={setRiskAnalysisState}
            analysis={analysis}
            selectedRisk={selectedRisk}
            open={modals.analyseEvaluateModal}
            close={() => toggleModal('analyseEvaluateModal', false)}
            disabled={disabled || selectedRisk?.determined}
         />
      </>
   )
}
